export enum PermissionExpressBasicOption {
  EXPRESS_BASIC_COMMON_LOGIN = 'express-basic',
  EXPRESS_BASIC_SERVICES_REQUEST_SERVICE = '/express/solicitud-de-servicio',
  EXPRESS_BASIC_SERVICES_MERCHANDISE = '/express/mercancia',
  EXPRESS_BASIC_SERVICES_PAYMENT = '/express/pago',
  EXPRESS_BASIC_SERVICES_LOAD_STOP = 'express-basic.loadStop',
  EXPRESS_BASIC_SERVICES_SCHEDULE = 'express-basic.schedule',
  EXPRESS_BASIC_SERVICES_ADD_STOP = 'express-basic.addStop',
  EXPRESS_BASIC_SERVICES_ADD_ROUND_TRIP = 'express-basic.addRoundTrip',
  EXPRESS_BASIC_SERVICES_DETAIL_BY_SERVICEID = '/express/detalle',
  EXPRESS_BASIC_SERVICES_DETAIL = '/express/detalle/',
  EXPRESS_BASIC_SERVICES = '/express/servicios',
  EXPRESS_BASIC_SERVICES_ACTIVE_LIST = 'express-basic.services.list',
  EXPRESS_BASIC_SERVICES_HISTORIC_LIST = 'express-basic.historicServices.list',
  EXPRESS_BASIC_SERVICES_EVIDENCES = 'express-basic.services.evidences',
  EXPRESS_BASIC_SERVICES_RATE = 'express-basic.services.rate',
  EXPRESS_BASIC_SERVICES_CANCEL = 'express-basic.services.cancel',
  EXPRESS_BASIC_PAYMENTMETHODS = 'express-basic.paymentMethods.hideDifferentPostpayment',
  EXPRESS_BASIC_PAYMENT_METHODS_CREDIT_CARDS_ON_POSTPAID = 'express-basic.paymentMethods.creditCardsOnPostpaid',

  /** FLAGS */
  EXPRESS_BASIC_FLAG_LIST_ADD_CREDIT_CARD_CO = 'express_basic_flag_list_add_credit_card_co',
  EXPRESS_BASIC_FLAG_LIST_ADD_CREDIT_CARD_MX = 'express_basic_flag_list_add_credit_card_mx',
  EXPRESS_BASIC_FLAG_PREPAID_CO = 'express_basic_flag_prepaid_co',
  EXPRESS_BASIC_FLAG_PREPAID_MX = 'express_basic_flag_prepaid_mx',
}
